import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// エントリー商材一覧取得
export async function getIncentiveServices(id: string) {
  try {
    const path = "incentiveServices";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      serviceDatas: response.data.service_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// エントリー商材登録
export async function postIncentiveServices(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "incentiveServices";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
